import { render, staticRenderFns } from "./posts-map.vue?vue&type=template&id=0a924f80&scoped=true"
import script from "./posts-map.vue?vue&type=script&lang=js"
export * from "./posts-map.vue?vue&type=script&lang=js"
import style0 from "./posts-map.vue?vue&type=style&index=0&id=0a924f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a924f80",
  null
  
)

export default component.exports